import { render, staticRenderFns } from "./RecentViewed.vue?vue&type=template&id=7d08c9e2&scoped=true"
import script from "./RecentViewed.vue?vue&type=script&lang=js"
export * from "./RecentViewed.vue?vue&type=script&lang=js"
import style0 from "./RecentViewed.vue?vue&type=style&index=0&id=7d08c9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08c9e2",
  null
  
)

export default component.exports